<template>
  <div
    class="white-color"
    :class="{
      [config.theme + '-theme']: true
    }"
    id="app"
  >
    <header id="hat">
      <logo />
      <!--search/-->
      <!--div class="dop-info">
        <dop-menu />
      </div-->
      <main-menu />
      <div class="right-grow">
        <div class="time" style="margin-top: 14px; color: white; margin-left: 10px; font-size: 14px; font-weight: bold; word-break: break-all; float: right; margin-right: 20px;" :key="localeDate">{{ this.localeDate | moment('HH:mm:ss') }}</div>
        <language-switcher />
        <div class="flex" :style="{ width: '440px' }" style="margin-left:3px;margin-right: 3px;">
          <!--fridge-button side="light" @down="pullBetSlipDown" @up="pullBetSlipUp" /-->
          <div class="right-grow" v-if="!isUserLoggedIn">
            <color-button color="yellow" class="register-button auth-button" @click="$store.commit('SHOW_MODAL', 'REGISTER')">{{ $t('modals.register.submit') }}</color-button>
            <color-button color="yellow" class="login-button auth-button" @click="$store.commit('SHOW_MODAL', 'LOGIN')">{{ $t('modals.login.submit') }}</color-button>
          </div>
          <div class="right-grow" v-else>
            <account-menu />
            <div class="account-amounts">
              <div class="row">
                <div class="account-amount-name">{{ $t('account.balance') }}</div>
                <div class="account-amount">{{ (accountBalance - accountBonus).toFixed(2) }} {{ currency }}</div>
              </div>
              <div class="row">
                <div class="account-amount-name">{{ $t('account.unplayed') }}</div>
                <div class="account-amount">{{ accountUnplayed }} {{ currency }}</div>
              </div>
              <div class="row">
                <div class="account-amount-name">{{ $t('account.bonus') }}</div>
                <div class="account-amount">{{ accountBonus }} {{ currency }}</div>
              </div>
            </div>
          </div>
          <!--div class="time" style="margin-top: 16px; margin-right: 20px; font-size: 16px;" :key="localeDate">{{ this.localeDate | moment('DD-MM-YYYY HH:mm:ss') }}</div-->
        </div>
        <!--language-switcher /-->
        <!--a href="https://api.betspectrum.com/files/mct/app.apk" style="margin-top: 13px; margin-right: 10px;"><img src="https://api.betspectrum.com/files/mct/cellphone-android.svg" /></a-->
      </div>
    </header>
    <m-layout-mask class="main-layout-mask">
      <m-layout grow>
        <router-view />
      </m-layout>
      <m-layout :style="{ width: '440px' }" style="margin-left:3px;margin-right: 3px;" v-if="!isActive('view', 'casino')">
        <m-scrollbar id="page-right-scroll" :key="isUserLoggedIn && positions.length">
          <!--bet-slip v-if="isUserLoggedIn" /-->
          <!--fon-bet-slip v-if="isUserLoggedIn" /-->
          <fon-bet-slip />
          <!--div class="league-banners" v-if="!positions.length">
            <league-banner v-for="(banner, i) in banners" :key="i" :banner="banner" />
          </div-->
          <!--div class="support" v-if="!positions.length">
            <div class="row-support">{{ $t('common.support') }}</div>
            <div class="row-support"> support@betstil.com </div>
          </div-->
        </m-scrollbar>
      </m-layout>
    </m-layout-mask>
    <register-modal v-if="modals.REGISTER" @close="$store.commit('CLOSE_MODAL', 'REGISTER')" />
    <login-modal v-if="modals.LOGIN" @close="$store.commit('CLOSE_MODAL', 'LOGIN')" />
    <password-recovery-modal v-if="modals.PASSWORD_RECOVERY" @close="$store.commit('CLOSE_MODAL', 'PASSWORD_RECOVERY')" />
  </div>
</template>

<script>
import MLayoutMask from '@/components/layouts/MLayoutMask'
import MLayout from '@/components/layouts/MLayout'
import MScrollbar from '@/components/MScrollbar'

import ColorButton from '@/components/buttons/ColorButton'
import FridgeButton from '@/components/buttons/FridgeButton'
import LanguageSwitcher from '@/components/header/LanguageSwitcher'

import Search from '@/components/header/Search'
import MainMenu from '@/components/header/MainMenu'
import AccountMenu from '@/components/header/AccountMenu'
import BetSlip from '@/components/bet-slip/BetSlip'
import FonBetSlip from '@/components/fon-bet-slip/BetSlip'

import RegisterModal from '@/components/modals/Register'
import LoginModal from '@/components/modals/Login'
import PasswordRecoveryModal from '@/components/modals/PasswordRecovery'

import LeagueBanner from '@/components/LeagueBanner'
import SlotBanner from '@/components/SlotBanner'
import DopMenu from '@/components/header/DopMenu'

import { routeProp } from '@/mixins/routeProp'
import { mapState } from 'vuex'

import config from '@/config/default'
import Logo from '@/Logo'

export default {
  name: 'App',
  metaInfo: {
    title: config.title,
    meta: [
      { vmid: 'description', property: 'description', content: config.title },
      { vmid: 'og:title', property: 'og:title', content: config.title },
      { vmid: 'og:description', property: 'og:description', content: config.title }
    ]
  },
  mixins: [ routeProp ],
  components: {
    MLayoutMask,
    MLayout,
    MScrollbar,

    ColorButton,
    FridgeButton,
    LanguageSwitcher,

    Search,
    MainMenu,
    AccountMenu,
    BetSlip,
    FonBetSlip,

    RegisterModal,
    LoginModal,
    PasswordRecoveryModal,

    LeagueBanner,
    SlotBanner,
    DopMenu,

    Logo
  },
  computed: {
    ...mapState({
      modals: state => state.modals,
      positions: state => state.betSlip.positions,

      isUserLoggedIn: state => state.isUserLoggedIn,

      accountBalance: state => state.account.actual.balance,
      accountUnplayed: state => state.account.actual.unplayed,
      accountBonus: state => state.account.actual.bonus,
      currency: state => state.user.currency
    })
  },
  data () {
    return {
      intervals: {
        favorites: null,
        updateInterval: null
      },
      intervalId: null,
      localeDate: '',
      banners: [
        // { alias: 'liga', sport: 1, league: 14798 },
        { alias: 'uefa-euro-2024', sport: 1, league: 14811 }
        // { alias: 'nhl', sport: 4, league: 16354 }
        // { alias: 'nba', sport: 2, league: 15929 }
      ]
    }
  },
  mounted () {
    let checkFavorites = () => {
      this.$store.dispatch('favorites/CHECK')
    }
    this.intervals.favorites = setInterval(function () {
      checkFavorites()
    }, 1000)
    this.intervalId = setInterval(this.getNow, 1000)
    this.getActualAccountData()
    this.updateInterval = setInterval(this.getActualAccountData.bind(this), 1000)
  },
  beforeDestroy () {
    clearInterval(this.intervals.favorites)
  },
  methods: {
    pullBetSlipUp () {
      let el = document.querySelector('#page-right-scroll')
      el.scrollTop = 0
    },
    pullBetSlipDown () {
      let el = document.querySelector('#page-right-scroll')
      let slip = document.querySelector('#bet-slip')
      el.scrollTop = slip.clientHeight - el.clientHeight
    },
    getActualAccountData () {
      this.$store.dispatch('account/GET_ACTUAL')
    },
    getNow: function () {
      const today = new Date()
      const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
      const timer = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds()
      this.localeDate = date + ' ' + timer
    }
  }
}
</script>

<style scoped>
header { /* background: #126e51; */ background-image: linear-gradient(to top right, #713592, #342d6e); display: flex; height: 50px; margin-bottom: -50px; position: relative; z-index: 1000; }
.logo { cursor: pointer; font-size: 16px; font-weight: bold; line-height: 50px; padding: 0 15px; text-transform: uppercase; }

.auth-button { margin: 10px 15px 0 0; }
.auth-button.register-button { /* border-radius: 0 3px 3px 0; */ border-radius: 10px; /* padding-left: 10px; */ }
.auth-button.login-button { /* border-radius: 3px 0 0 3px; */ border-radius: 10px; margin-right: 5px; /* padding-right: 10px; */ }

.account-amounts { display: table; /* padding: 8px 0; */ }
.account-amounts .row { display: table-row; height: 17px; line-height: 17px; text-align: right; }
.account-amounts .row > div { display: table-cell; }

.account-amount { color: #ddd; text-align: right; }
.account-amount-name { color: #ddd; padding-right: 10px; text-align: left; }

.main-layout-mask { padding-top: 51px; }

.league-banners { /* border-bottom: 1px solid rgba(255, 255, 255, .07); */ padding: 0 1px 10px; }
.league-banners .league-banner { margin-top: 4px; }
.dop-info { margin-top: 50px; height: 31px; background: #126e51; border-top: 1px solid white; border-top: 1px solid darkgray; width: 100%; position: absolute; }

</style>

<style>
* { box-sizing: border-box; margin: 0; padding: 0; }
html, body { height: 100%; max-height: 100%; min-height: 50px; }
#app, button, input, textarea {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#app {
  /* background: #383838; */
  background: #f5f5f5;
  height: 100%;
  min-width: 1280px;
  overflow: hidden;
  position: relative;
  color: #231e4a;
}
#app.alegreya-theme,
#app.alegreya-theme button,
#app.alegreya-theme input,
#app.alegreya-theme textarea {
  font-family: "Roboto Condensed","ravkavonline","-apple-system","Helvetica Neue","Roboto","Segoe UI",sans-serif;
  text-rendering: optimizeLegibility;
  font-size: 13px;
  font-weight: 600 !important;
  font-feature-settings: "kern";
}
#app.segoe-theme,
#app.segoe-theme button,
#app.segoe-theme input,
#app.segoe-theme textarea { font: 13px -apple-system, BlinkMacSystemFont, Segoe UI, San Francisco, Arial, Helvetica, sans-serif; }

.link { color: #2c3e50; cursor: pointer; -webkit-transition: color .3s; -moz-transition: color .3s; -o-transition: color .3s; transition: color .3s; }
.link:hover { color: #8c9eff; }

.flex { display: flex; }
.right-flex { display: flex; flex: 1 1; flex-direction: row-reverse; }
.left-flex { display: flex; flex: 1 1; flex-direction: row; }
.right-grow { display: flex; flex-direction: row-reverse; flex-grow: 1; }
.left-grow { display: flex; flex-grow: 1; }

.hidden { display: none !important; }
.ellipsis { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

.white-color { /* color: #cecece; */ }
.dark-color { color: #2c3e50; }
.blue-color { color: #8c9eff; }
.green-color { color: #43a047; }
.red-color { color: #f44336; }
.orange-color { color: #ffa726; }
.yellow-color { color: #ffd54f; }
.gold-color { color: #d4af37; }
.gray-color { color: #999; }

.gold-bg { background: #d4af37; }

.active-button--blue-line:before {
    background: #8ce95d !important;
}

.active-button--white-line:before {
    /* background: #ffdf1b !important;
    background: #8ce95d !important; */
    margin-bottom: 2px;
}

nav .active-button {
    color: #fff;
    font-size: 13px !important;
    height: 50px;
    line-height: 50px !important;
    padding: 0 10px;
}

.item { background: #cecece !important; }
.item.active { background: #713592 !important; }

.number { display: none !important; }

.active.market-filter-option {
    background: none !important;
    box-shadow: none !important;
    border-bottom: 2px solid #342d6e !important;
    border-radius: 0px !important;
}

.account-circle-icon {
  color: white !important;
}

/* .matches-layout {
  margin-top: -50px !important;
} */

.event-extra b {
  color: #713592 !important;
}

/* .settings-button {
  display: none !important;
} */

.head {
  background: none !important;
}

.f.factor-cell {border-radius: 10px !important;}
.l.factor-cell {border-radius: 10px !important;}
.f .event-cell {border-radius: 10px !important;}
.l .event-cell {border-radius: 10px !important;}

.factor-cell-value {color: #231e4a !important; }

.disabled.factor-cell .factor-cell-value { color: #231e4a !important; }

.factor-cell {color: #231e4a; background: #d4dbe3 !important; border-radius: 10px !important; margin-top: 1px; margin-bottom: 1px; margin-left: 2px;}
.disabled.factor-cell {color: #231e4a !important; background: #d4dbe3 !important; border-radius: 10px !important;}

.score {color: darkorange !important; font-weight: bold !important;}

.event.event {
  margin-top: 2px;
  background: white;
  border-radius: 10px;
}

.sub-event {
  margin-top: 1px;
}

.cell {
  background: #d4dbe3 !important;
  border-radius: 10px !important;
}

.disabled.cell {
  background: #d4dbe3 !important;
}

.cell.selected {
  background: #8ce95d !important;
}

.cell.factor-cell.point {
  color: #231e4a !important;
  font-size: 12px !important;
}

.cell.factor-cell.point,
.cell.factor-cell.point:hover {
  background: white !important;
}

.cell.selected,
.factor-cell.selected {
  outline: none !important;
  background: #8ce95d !important;
}

.cell:hover,
.factor-cell:hover {
  outline: none !important;
  background: #8ce95d !important;
}

.factor-names > div,
.factor-names > div:hover {
  background: none !important;
}

.disabled.cell:hover,
.disabled.factor-cell:hover {
  background: #d4dbe3 !important;
}

.live-overview-list {
    margin: 0 0 !important;
    position: relative;
}
.prematch-matches-list {
    margin: 0 0 !important;
    position: relative;
}

.matches-page,
.matches-layout {
    margin-left: 5px;
}
.matches-page .matches-layout {
    margin-left: 0 !important;
}

.textito { background: #ffd54f !important; color: black !important; }
.message { color: white !important; }
.warning { background: none !important; }

.matches-head { background: #303030 !important; margin: 0 0 2px !important;}
.live-widget-head { background: #303030 !important; margin: 0 0 2px !important; }

.scroll-area { /* background: #383838 !important; */ }
.league-hat { background: white !important; margin-top: 2px; border-radius: 10px; }
.league-hat:hover { background: #d4dbe3 !important; }

.sport-hat { /* margin-top: -5px !important; */ }

:focus { outline: none; }
::-moz-focus-inner { border: 0; }

input,
textarea { border: 1px solid #a2adbf; border-radius: 3px; }
input:focus,
textarea:focus { border-color: #8c9eff; box-shadow: inset 0 0 3px rgba(0, 0, 0, .3); }
input { height: 30px; line-height: 28px; padding: 0 10px; }
textarea { padding: 10px 15px; }

input,
textarea { -webkit-transition: all .3s; -moz-transition: all .3s; -o-transition: all .3s; transition: all .3s; }

.form-element { color: #555; display: flex; flex-direction: column; margin-bottom: 15px; text-align: left; }
.form-element label { font-weight: 700; margin-bottom: 4px; }
.board-form-element { display: flex; margin-bottom: 10px; }
.board-form-element > div { align-items: center; display: flex; flex: 1; }
.board-form-element-key { flex-direction: row-reverse; padding: 0 10px; }
.board-form-element-value { padding-right: 10px; }
.board-form-message { /* border-radius: 5px; */ padding: 10px; }
.board-form-error-message { background: #f44336; }
.board-form-success-message { background: #43a047; }

.comment > div { color: #713592 !important; }
.point { font-weight: normal !important; }

.hooper-slide { background: lightgray !important; }
.hooper-slide:hover { background: #8ce95d !important; border-left: 1px solid white; border-right: 1px solid white; }
.hooper-list { border-radius: 10px !important; }

.time-blink { /* animation: time-blink 1s linear infinite; -webkit-animation: time-blink 1s linear infinite; */ }
@keyframes time-blink { 0% { opacity: 0; } 50% { opacity: 1; } 100% { opacity: 0; }}
@-webkit-keyframes time-blink { 0% { opacity: 0; } 50% { opacity: 1; } 100% { opacity: 0; }}

.inc-blink:after { border-top: 10px solid transparent; border-left: 10px solid transparent; content: ''; height: 0; position: absolute; right: 0; top: 0; width: 0; animation: inc-blink 1s linear infinite; -webkit-animation: inc-blink 1s linear infinite; }
@keyframes inc-blink { 0% { border-top-color: transparent; } 50% { border-top-color: #43a047; } 100% { border-top-color: transparent; }}
@-webkit-keyframes inc-blink { 0% { border-top-color: transparent; } 50% { border-top-color: #43a047; } 100% { border-top-color: transparent; }}
.dec-blink:after { border-left: 10px solid transparent; border-bottom: 10px solid transparent; bottom: 0; content: ''; height: 0; position: absolute; right: 0; width: 0; animation: dec-blink 1s linear infinite; -webkit-animation: dec-blink 1s linear infinite; }
@keyframes dec-blink { 0% { border-bottom-color: transparent; } 50% { border-bottom-color: #f44336; } 100% { border-bottom-color: transparent; }}
@-webkit-keyframes dec-blink { 0% { border-bottom-color: transparent; } 50% { border-bottom-color: #f44336; } 100% { border-bottom-color: transparent; }}

.material-design-icon { display: block; position: relative; -webkit-transition: all .3s; -moz-transition: all .3s; -o-transition: all .3s; transition: all .3s; }
.material-design-icon > svg { left: 0; position: absolute; top: 0; }

.support { /* margin-top: 5px; */ height: 55px; /* border-radius: 5px; */ opacity: .9; overflow: hidden; position: relative; width: 329px; margin-left: 1px; background: #8ce95d; font-size: 11pt; }
.support .row-support { height: 30px; background: #8ce95d; color: white; margin-left: 16px; text-align: center; margin-bottom: -15px; margin-top: 8px; }

.factor-names { font-weight: 600 !important; }

</style>



// WEBPACK FOOTER //
// src/App.vue